import { render, staticRenderFns } from "./selfOrder.vue?vue&type=template&id=f5333540&scoped=true"
import script from "./selfOrder.vue?vue&type=script&lang=js"
export * from "./selfOrder.vue?vue&type=script&lang=js"
import style0 from "./selfOrder.vue?vue&type=style&index=0&id=f5333540&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5333540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5333540')) {
      api.createRecord('f5333540', component.options)
    } else {
      api.reload('f5333540', component.options)
    }
    module.hot.accept("./selfOrder.vue?vue&type=template&id=f5333540&scoped=true", function () {
      api.rerender('f5333540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/selfOfficialOrder/selfOrder.vue"
export default component.exports